import React from 'react';

const AsyncLicensingContainer = React.lazy(
	() => import('containers/desktop/Special/Licensing/Licensing')
);

const publicRoutes = [{ path: '/licensing', Component: AsyncLicensingContainer }];

export default [...publicRoutes];
